import './Spinner.css';

/** Indicador de carga. Si se pasa `label`, lo muestra al lado (estado de carga inline). */
export default function Spinner({ label }) {
  return (
    <span className="spinner-row" role="status">
      <span className="spinner" aria-hidden="true" />
      {label && <span>{label}</span>}
      <span className="sr-only">Cargando…</span>
    </span>
  );
}
